/**
 * A aba está à vista? — para o `useSyncExternalStore` (número de posts novos do Feed no menu).
 *
 * `abaVisivel` é o instantâneo (booleano, comparável por valor: o React não re-renderiza sem
 * mudança) e `assinarAbaVisivel` avisa quando a aba aparece ou esconde (`visibilitychange`).
 * Mesma ideia da "sala à vista" do chat (`salaAberta.ts`), sem a parte da sala.
 */

export function abaVisivel(): boolean {
  return typeof document === "undefined" || document.visibilityState === "visible";
}

/** Assina o `visibilitychange` do `document`. Devolve o cancelamento. */
export function assinarAbaVisivel(cb: () => void): () => void {
  if (typeof document === "undefined") return () => {};
  document.addEventListener("visibilitychange", cb);
  return () => document.removeEventListener("visibilitychange", cb);
}
